export default __webpack_public_path__ + "static/media/questionImage.66ae7ec8.jpg";